import React from 'react';
import { ChipRow, DateChipStyled, OtherChipStyled, ChipLine1, ChipLine2 } from './chip';
import { getDateChipLabel, isSameDay } from './helpers';

const DateChips = ({ dates, selectedDate, onSelectDate, onOtherClick }) => {
  return (
    <ChipRow>
      {dates.map((date, idx) => {
        const label = getDateChipLabel(date);
        return (
          <DateChipStyled
            key={idx}
            type="button"
            isSelected={isSameDay(date, selectedDate)}
            onClick={() => onSelectDate(date)}>
            <ChipLine1>{label.line1}</ChipLine1>
            <ChipLine2>{label.line2}</ChipLine2>
          </DateChipStyled>
        );
      })}
      <OtherChipStyled type="button" onClick={onOtherClick}>
        <ChipLine1>Other</ChipLine1>
        <ChipLine2>
          <i className="fa-light fa-calendar" />
        </ChipLine2>
      </OtherChipStyled>
    </ChipRow>
  );
};

export default DateChips;
